import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProgressBarMode, MatProgressBarModule } from '@angular/material/progress-bar';
import { CdkAriaLive } from '@angular/cdk/a11y';

@Component({
  selector: 'app-progress-bar',
  imports: [
    MatProgressBarModule,
    CdkAriaLive,
  ],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.css',
  standalone: true,
})
export class ProgressBarComponent implements OnChanges {
  mode: ProgressBarMode = 'determinate';
  value = 0;
  @Input() questNo!: number;
  @Input() totalQuestions!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['questNo'] || changes['totalQuestions']) && this.totalQuestions > 0) {
      this.value = ((this.questNo + 1) / this.totalQuestions) * 100;
    }
  }
}
